export const pathToLocation = (path: string, params: Record<string, string>) => {
  const urlSearchParams = Object.entries(params).reduce((s, [k, v]) => {
    if (typeof v === 'undefined') return s;
    return (s ? `${s}&` : '?') + (v !== null ? `${k}=${encodeURIComponent(v)}` : k);
  }, '');

  return (path.substr(0, 4) === 'http' ? path : window.location.origin + path) + urlSearchParams;
};
